export default {
  discover: {
    market: {
      title: 'Discover the best Agentic patterns',
      searchPlaceholder: 'Find your next agentic workflow template...',
      tabs: {
        template: 'Templates',
        buildIn: 'Build in',
      },
      filter: {
        mySubmissions: 'Submitted by me',
        sortBy: 'Sort by:',
        updatedTime: 'Updated Time',
        usageCount: 'Usage Count',
      },
      categories: {
        database: 'Database',
        model: 'Model',
        productivity: 'Productivity',
        creative: 'Creative',
      },
    },
    detail: {
      installs: 'installs',
      install: 'Install',
      useTemplate: 'Use Template',
      tabs: {
        overview: 'Overview',
      },
      configuration: 'Configuration',
      category: 'Category',
      tags: 'Tags',
      currentVersion: 'Current Version',
      versionHistory: 'Version History',
      updatedBy: 'Updated by',
      creditsInfo: 'Credits Info',
      copyCost: 'Copy cost',
      authorReward: 'Author reward',
      credits: 'Credits',
      messages: {
        installSuccessOwner:
          'Installed successfully (No credits deducted as owner)',
        insufficientCredits: 'Insufficient credits',
        copying: 'Copying to workspace...',
        copySuccess: 'Copied successfully!',
      },
    },
  },
};
